(()=>{'use strict';
 function initMobileDismiss(){
  if(document.documentElement.dataset.hxMobileDismissReady)return;
  document.documentElement.dataset.hxMobileDismissReady='true';
  const mobile=window.matchMedia('(max-width:1050px)');
  const isEditing=target=>target instanceof Element&&Boolean(target.closest('input,select,textarea'));
  const dismiss=()=>{
   if(!mobile.matches)return;
   const nav=document.querySelector('#nav.open');
   if(nav){
    const toggle=document.querySelector('#menuToggle');
    const restoreFocus=nav.contains(document.activeElement);
    nav.querySelectorAll('localization-form').forEach(picker=>{if(typeof picker.hidePanel==='function')picker.hidePanel();});
    nav.classList.remove('open');
    toggle?.setAttribute('aria-expanded','false');
    if(restoreFocus)toggle?.focus({preventScroll:true});
   }
   const drawer=document.querySelector('#Drawer-Menu.active');
   if(drawer&&typeof drawer.close==='function')drawer.close();
  };
  let touchY=null;
  let lastScrollY=window.scrollY;
  document.addEventListener('touchstart',event=>{touchY=event.touches.length===1?event.touches[0].clientY:null;},{passive:true});
  document.addEventListener('touchmove',event=>{
   if(touchY===null||event.touches.length!==1||isEditing(event.target))return;
   if(touchY-event.touches[0].clientY>12){dismiss();touchY=null;}
  },{passive:true});
  document.addEventListener('touchend',()=>{touchY=null;},{passive:true});
  document.addEventListener('touchcancel',()=>{touchY=null;},{passive:true});
  document.addEventListener('wheel',event=>{if(event.deltaY>4&&!isEditing(event.target))dismiss();},{passive:true});
  window.addEventListener('scroll',()=>{
   const currentY=window.scrollY;
   if(currentY>lastScrollY+1) dismiss();
   lastScrollY=currentY;
  },{passive:true});
 }
 function init(){
  const header=document.querySelector('#shopify-section-v22-header');
  if(!header||header.dataset.hxUtilitiesReady)return;
  header.dataset.hxUtilitiesReady='true';
  header.querySelectorAll('.hx-header-localization').forEach(form=>{
   form.dataset.enhanced='true';
   form.addEventListener('change',event=>{if(event.target.matches('[data-hx-localization-select]'))form.requestSubmit();});
  });
  const measure=()=>document.documentElement.style.setProperty('--hx-sticky-header-height',`${header.getBoundingClientRect().height}px`);
  const observer=new ResizeObserver(measure);observer.observe(header);measure();
  const drawer=document.querySelector('#Drawer-Menu');
  const toggle=document.querySelector('#menuToggle');
  if(drawer&&toggle){
   const sync=()=>{
    const open=drawer.classList.contains('active');
    toggle.setAttribute('aria-expanded',String(open));
    if(!open)drawer.querySelectorAll('drawer-localization-component,localization-form').forEach(picker=>{if(picker.querySelector('.selector__dropdown.active')&&typeof picker.hidePanel==='function')picker.hidePanel();});
   };
   new MutationObserver(sync).observe(drawer,{attributes:true,attributeFilter:['class']});sync();
   drawer.addEventListener('click',event=>{if(event.target.closest('.menu-drawer__menu a')&&drawer.classList.contains('active'))drawer.close();});
   window.matchMedia('(min-width:1051px)').addEventListener('change',event=>{if(event.matches&&drawer.classList.contains('active'))drawer.close();});
  }
  document.addEventListener('shopify:section:unload',function cleanup(event){if(event.target===header){observer.disconnect();document.removeEventListener('shopify:section:unload',cleanup);}});
 }
 initMobileDismiss();init();document.addEventListener('shopify:section:load',init);
})();
